const ELLIPSIS = "...";

const collapseWhitespace = (text: string): string => text.replace(/\s+/g, " ").trim();

/**
 * One-line excerpt around the first case-insensitive match of `query`.
 * Leading `...` only if text before the excerpt was omitted; trailing `...` only if more text follows.
 */
export const buildSummaryExcerptAroundQuery = (summary: string, query: string, maxBodyChars = 120): string => {
    const normalized = collapseWhitespace(summary);
    const q = query.trim();
    if (!q || !normalized) {
        return "";
    }

    const lower = normalized.toLowerCase();
    const needle = q.toLowerCase();
    const matchIndex = lower.indexOf(needle);
    if (matchIndex === -1) {
        const head = normalized.slice(0, maxBodyChars);
        return normalized.length > maxBodyChars ? `${head}${ELLIPSIS}` : head;
    }

    const matchLength = q.length;

    let start = matchIndex - Math.floor((maxBodyChars - matchLength) / 2);
    if (start < 0) {
        start = 0;
    }
    let end = Math.min(normalized.length, start + maxBodyChars);
    if (end - start < maxBodyChars) {
        start = Math.max(0, end - maxBodyChars);
    }

    const body = normalized.slice(start, end);
    const leadingEllipsis = start > 0;
    const trailingEllipsis = end < normalized.length;

    return `${leadingEllipsis ? ELLIPSIS : ""}${body}${trailingEllipsis ? ELLIPSIS : ""}`;
};
